import axios from "axios";

export default {
	async index() {
		return await axios.get("/notifications");
	},
	async showed() {
		return await axios.put("/notifications");
	},
};